import TileLayer from 'ol/layer/Tile';
import { TileWMS } from 'ol/source';
import { sksisUrls } from './urls';

const webMercatorProjection = 'EPSG:3857';

export const staticPolygonsLayer = new TileLayer({
  visible: true,
  source: new TileWMS({
    projection: webMercatorProjection,
    url: new sksisUrls().geoserverBaseURL,
    params: {
      VERSION: '1.1.1',
      tiled: true,
      STYLES: '',
      LAYERS: 'dss:polygon_theme',
    },
    crossOrigin: 'anonymous',
  }),
});